// @flow
import { get } from 'lodash';

import { filterAccommodations } from 'Components/widgets/additional-accommodations/AdditionalAccommodationsUtils';
import {
  CLEAR_ADDITIONAL_ACCOMMODATIONS,
  CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS,
  FETCH_ADDITIONAL_ACCOMMODATIONS,
  TOGGLE_ACCOMMODATIONS_FILTER,
  UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';

import {
  getFiltersWithMatchedOccurrences,
  toggleFilter,
  getPreselectedFilters,
} from 'Store/filters/filtersHelper';

import { createFilters, unselectCategory } from './filterUtils';

type State = ?Array<Filter>;

const initialState: State = null;

export function filtersReducer(state: State = initialState, action: Action<*>): State {
  const additionalAccommodations = get(action, 'payload.additionalAccommodations') || [];
  const proposal = get(action, 'payload.selectedProposal') || null;

  // remove initial accommodation (related to selected proposal) from additional accommodations
  const filteredAdditionalAccommodations =
    proposal && additionalAccommodations.length
      ? filterAccommodations(proposal, additionalAccommodations)
      : additionalAccommodations;

  const getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(
    filteredAdditionalAccommodations,
  );

  switch (action.type) {
    case CLEAR_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return initialState;

    case CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS:
      const { i18n, selectedProposal, shouldPreselectFilters, resort } = action.payload;
      const filters = createFilters(filteredAdditionalAccommodations, i18n, resort);
      const filtersWithOccurences = getFiltersWithOccurrences(filters);
      return filtersWithOccurences && shouldPreselectFilters
        ? getPreselectedFilters(filtersWithOccurences, selectedProposal)
        : filtersWithOccurences;

    case TOGGLE_ACCOMMODATIONS_FILTER:
      const { filter } = action.payload;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY:
      const { category } = action.payload;
      const updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
